import styled, { css } from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const Download = styled.div`
  padding: ${space.xl3} 0;
  background-color: ${color.grayscale.lighter};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.xl3} 0 ${space.xl4};
  }
`

export const Logos = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.xl2} ${space.lg};
  margin-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.md}) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${space.xl2} ${space.lg};
    margin-bottom: ${space.xl2};
  }

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(3, 1fr);
    gap: ${space.md};
    padding-right: ${space.xl2};
  }
`

export const LogoCard = styled.div`
  padding-bottom: ${space.lg};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.white};

  @media (min-width: ${breakpoint.lg}) {
    background-color: transparent;
  }
`

export const WrapperImageLogo = styled.div<{ dark?: boolean }>`
  position: relative;
  background-color: ${({ dark }) => (dark ? color.primary.darker : color.grayscale.white)};
  overflow: hidden;
  ${({ dark }) =>
    !dark &&
    css`
      border-bottom: ${borders.sizes.md} dashed ${color.grayscale.light};
    `}

  @media (min-width: ${breakpoint.md}) {
    border-radius: ${borders.radius.lg} ${borders.radius.lg} 0 0;
  }

  @media (min-width: ${breakpoint.lg}) {
    border-radius: ${borders.radius.lg};
    border-bottom: none;
  }
`

export const AnchorList = styled.nav`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: ${space.lg};
`

export const Anchor = styled.a`
  padding: ${space.xs} ${space.sm};
  border: ${borders.sizes.sm} solid ${color.primary.dark};
  border-radius: ${borders.radius.lg};
  color: ${color.primary.darker};
  font-family: ${font.family.text};
  font-size: ${font.size.small};
  line-height: ${font.lineHeight.sm};
  font-weight: ${font.weight.medium};
  text-transform: uppercase;
  transition: all 0.25s ease;

  &:not(:last-of-type) {
    margin-right: ${space.sm};
  }

  &:hover {
    background-color: ${color.primary.light};
    border-color: ${color.primary.light};
    text-decoration: none;
  }
`
